import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  //   apiKey: "YOUR_API_KEY",
  //   authDomain: "YOUR_DOMAIN",
  //   projectId: "YOUR_PROJECT_ID",
  //   messagingSenderId: "YOUR_SENDER_ID",
  //   appId: "YOUR_APP_ID",

  // test 
  apiKey: "AIzaSyCtqCswpLZ_Xt7MVn7qYTGngJ3KdvVry64",
  authDomain: "push-notification-f413f.firebaseapp.com",
  projectId: "push-notification-f413f",
  messagingSenderId: "863671357370",
  appId: "1:863671357370:web:0cda767e9ebf3471805783",

  // prod
  // apiKey: "AIzaSyDRLz0hhoUTJ93MHUxYeALFUE3lPfe77TI",
  // authDomain: "ep-live-7b72a.firebaseapp.com",
  // databaseURL: "https://ep-live-7b72a-default-rtdb.firebaseio.com",
  // projectId: "ep-live-7b72a",
  // storageBucket: "ep-live-7b72a.appspot.com",
  // messagingSenderId: "63242650506",
  // appId: "1:63242650506:web:7cddbb2cecbd029dcb7e73",
  // measurementId: "G-25H9Q9VYMV",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const getFirebaseMessaging = async () => {
  const supported = await isSupported();

  if (!supported) {
    return null;
  }

  return getMessaging(app);
};

export { app };

